import { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';

import Radar from '@cutwise/radar-chart';

import { EMPTY_VALUE_DASH } from '@/constants/common';
import { useStore } from '@/stores/StoreProvider';
import { reverseString } from '@/utils/reverseString';

import { OPTICAL_FIELDS } from './OpticalPerformance.constants';
import styles from './OpticalPerformance.module.scss';

function OpticalPerformance() {
  const { diamond } = useStore('diamondsStore');

  const radarRef = useRef<Nullable<SVGSVGElement>>(null);

  const radarProducts = diamond ? [diamond] : [];

  const hasOpticalPerformanceData = Boolean(diamond) && OPTICAL_FIELDS.some((field) => field.getterValue(diamond!) != null);

  function getChartData() {
    return radarProducts.map((diamond) =>
      OPTICAL_FIELDS.map((field) => ({
        axis: field.key,
        value: field.getterValue(diamond) ?? null,
        label: field.getter(diamond) ? reverseString(field.getter(diamond)!, '-') : EMPTY_VALUE_DASH,
      })),
    );
  }

  useEffect(() => {
    if (!hasOpticalPerformanceData) {
      return;
    }

    new Radar(
      radarRef.current as SVGSVGElement,
      OPTICAL_FIELDS.map((field) => ({
        code: field.key,
        label: field.getFullLabel ? field.getFullLabel(diamond!) : field.fullLabel,
        range: [0, 1],
      })),
      ['#F1B072', 'white'],
    ).draw(getChartData());
  }, [hasOpticalPerformanceData]);

  if (!hasOpticalPerformanceData) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className="container">
        <h2>Optical Performance</h2>

        <svg className={styles.svg} ref={radarRef} preserveAspectRatio="xMidYMid meet" viewBox="0 0 1000 1000" />
      </div>
    </div>
  );
}

export default observer(OpticalPerformance);
